/**
 * HELP-ICONS.UTILS
 * Icons inside the text of a guide : the editor of Strapi only keeps plain text, so an icon is written as [name]
 * and replaced by a FontAwesome icon when the guide is displayed
 */

//Names usable in the text of a guide : [rouge] [orange] [vert] have fixed colors, [couleur-basse] [couleur-moyenne] [couleur-haute]
//take the colors the account chose for its results
export const HELP_ICON_NAMES = ["rouge", "orange", "vert", "ok", "attention", "info", "couleur-basse", "couleur-moyenne", "couleur-haute", "pastille-basse", "pastille-egale", "pastille-haute", "rps-iso", "rps-job", "rps-actif", "rps-passif", "rps-detendu"] as const
export type HelpIconName = (typeof HELP_ICON_NAMES)[number]

//Icons of the tabs and zones of the dashboard, written [icone:participation] : they go in front of the name of a tab, like in the navigation
export const HELP_TAB_ICON_NAMES = [
  "overview",
  "participation",
  "questions",
  "matrice",
  "historique",
  "commentaires",
  "nps",
  "rps",
  "plan-action",
  "calcul",
  "confidentialite",
  "benchmark"
] as const
export type HelpTabIconName = (typeof HELP_TAB_ICON_NAMES)[number]

//Replace the [icone:name] of the tabs known
export function replaceHelpTabIconTokens(html: string, render: (name: HelpTabIconName) => string): string {
  return html.replace(/\[icone:(overview|participation|questions|matrice|historique|commentaires|nps|rps|plan-action|calcul|confidentialite|benchmark)\]/g, (_, name: HelpTabIconName) => render(name))
}

//Replace the [name] of the icons known, the other brackets stay as they are
export function replaceHelpIconTokens(html: string, render: (name: HelpIconName) => string): string {
  return html.replace(/\[(rouge|orange|vert|ok|attention|info|couleur-basse|couleur-moyenne|couleur-haute|pastille-basse|pastille-egale|pastille-haute|rps-iso|rps-job|rps-actif|rps-passif|rps-detendu)\]/g, (_, name: HelpIconName) => render(name))
}
